module.exports = new __parcel__URL__("stations.9cd55964.svg").toString();